import styled from 'styled-components';

const Wrapper = styled.div`
  height: 0;
  margin-bottom: 3rem;
  overflow: hidden;
  padding-top: calc(315 / 560 * 100%);
  position: relative;
`;

const Container = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const VideoPlayer = ({ url }) => {
  return (
    <Wrapper>
      <Container>
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          height="100%"
          src={url}
          title="YouTube video player"
          width="100%"
        ></iframe>
      </Container>
    </Wrapper>
  );
};

export default VideoPlayer;
